import React from "react";
import ct from "~/common/concat";
import TriangleTooltip from "./TriangleTooltip";
import Icon from "../../../../Icons/Standard";

interface Props {
  image: string;
  tooltipText: string;
}

const VideoThumbnail = ({ image, tooltipText }: Props) => {
  const overlay = `linear-gradient(
      rgba(0, 0, 0, 0.3),
      rgba(0, 0, 0, 0.3)
    ),
    url(${image})`;
  const backgroundStyles: React.CSSProperties = {
    backgroundImage: overlay,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };
  return (
    <>
      <TriangleTooltip label={tooltipText} aria-label={tooltipText}>
        <div
          className={ct(
            "flex",
            "items-center",
            "justify-center",
            "h-full",
            "relative",
            "w-full",
          )}
          style={backgroundStyles}
        >
          <Icon
            className={ct("fill-current", "text-white")}
            height="2.5rem"
            width="2.5rem"
            name="play"
          />{" "}
        </div>
      </TriangleTooltip>
    </>
  );
};

export default VideoThumbnail;
